import React from "react";
import { Controller } from "react-hook-form";
import { searchAdvancedFiltersFields } from "../../task-list/lib/constants";
import { DatePicker, Select, Textarea } from "../../form-inputs/inputs";
import { booleanOptions, statusBooleanOptions } from "../../../shared/constants/dropdown-options";
import { SHIPMENT_FILTER_TYPES } from "../../shipments/lib/constants";
import { useAdvancedFiltersForm } from "../../../shared/hooks/use-advanced-filters-form";
import { useClients } from "../hooks/use-clients";
import MultiSelectList from "../../form-inputs/custom/react-multi-select";
import { useLocations } from "../hooks/use-locations";
import { usePackageLevels } from "../hooks/use-package-levels";

export const AdminSearchForm = () => {
    const { control, findDefaultValues } = useAdvancedFiltersForm();
    const { data: cxhClients } = useClients(3);
    const { data: clients } = useClients(2);
    const { data: locations } = useLocations();
    const { data: packageLevels } = usePackageLevels();

    return (
        <>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.upc.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.upc.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">Publish Date</div>
                <div className="flex flex-2 advanced-filters-field">
                    <Controller
                        name={searchAdvancedFiltersFields.startDate.name}
                        control={control}
                        render={({ field }) => {
                            return (
                                <DatePicker
                                    className="m-r-16"
                                    emitAsString
                                    isClearable
                                    label="From"
                                    name={field.name}
                                    value={field.value}
                                    updateOnChange={(name, value) => field.onChange(value)}
                                    enableIcon
                                />
                            );
                        }}
                    />
                    <Controller
                        name={searchAdvancedFiltersFields.endDate.name}
                        control={control}
                        render={({ field }) => (
                            <DatePicker
                                className="m-l-16"
                                emitAsString
                                isClearable
                                label="To"
                                name={field.name}
                                enableIcon
                                value={field.value}
                                updateOnChange={(name, value) => field.onChange(value)}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.packageLevelName.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.packageLevelName.name}
                    control={control}
                    render={({ field }) => {
                        return (
                            <div className="flex-2 advanced-filters-field">
                                <MultiSelectList
                                    autoCloseClassName=".advanced-filters-body"
                                    defaultValue={findDefaultValues(packageLevels, field.value)}
                                    name={searchAdvancedFiltersFields.packageLevelName.label}
                                    options={packageLevels}
                                    updateOnChange={(name, values) => field.onChange(values)}
                                    clearSelections={field.value === ""}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.cxhClient.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.cxhClient.name}
                    control={control}
                    render={({ field }) => {
                        return (
                            <div className="flex-2 advanced-filters-field">
                                <MultiSelectList
                                    autoCloseClassName=".advanced-filters-body"
                                    defaultValue={findDefaultValues(cxhClients, field.value)}
                                    name={searchAdvancedFiltersFields.cxhClient.label}
                                    options={cxhClients}
                                    updateOnChange={(name, values) => field.onChange(values)}
                                    clearSelections={field.value === ""}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.gdnClient.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.gdnClient.name}
                    control={control}
                    render={({ field }) => {
                        return (
                            <div className="flex-2 advanced-filters-field">
                                <MultiSelectList
                                    autoCloseClassName=".advanced-filters-body"
                                    defaultValue={findDefaultValues(clients, field.value)}
                                    name={searchAdvancedFiltersFields.gdnClient.label}
                                    options={clients}
                                    updateOnChange={(name, values) => field.onChange(values)}
                                    showPagination={false}
                                    clearSelections={field.value === ""}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.location.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.location.name}
                    control={control}
                    render={({ field }) => {
                        return (
                            <div className="flex-2 advanced-filters-field">
                                <MultiSelectList
                                    autoCloseClassName=".advanced-filters-body"
                                    defaultValue={findDefaultValues(locations, field.value)}
                                    name={searchAdvancedFiltersFields.location.label}
                                    options={locations}
                                    updateOnChange={(name, values) => field.onChange(values)}
                                    clearSelections={field.value === ""}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.shipmentType.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.shipmentType.name}
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            className="flex-2 advanced-filters-field"
                            value={(field && field.value) || ""}
                            excludeSelect
                            options={SHIPMENT_FILTER_TYPES}
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.shipmentKey.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.shipmentKey.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.binTrackingNumber.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.binTrackingNumber.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.supplier.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.supplier.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.internalSupplierId.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.internalSupplierId.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row -align-start">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.correlationId.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.correlationId.name}
                    control={control}
                    render={({ field }) => (
                        <Textarea
                            {...field}
                            className="flex-2 advanced-filters-field"
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.status.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.status.name}
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            excludeSelect={false}
                            className="flex-2 advanced-filters-field"
                            options={statusBooleanOptions}
                        />
                    )}
                />
            </div>
            <div className="advanced-filters-row">
                <div className="advanced-filters-name flex-1">{searchAdvancedFiltersFields.isFinalized.label}</div>
                <Controller
                    name={searchAdvancedFiltersFields.isFinalized.name}
                    control={control}
                    render={({ field }) => (
                        <Select
                            {...field}
                            className="flex-2 advanced-filters-field"
                            excludeSelect={false}
                            value={(field && field.value) || ""}
                            options={booleanOptions}
                        />
                    )}
                />
            </div>
        </>
    );
};
